/**
 * Misha added the load function below, which is run on every route change.
 * His idea behind adding and removing the script from the DOM on each route
 * change was that the callrail script might not be built with SPA's in mind,
 * so it may need to be re-executed on each route change to do its thing.
 * I haven't verified this--execpt to note that the swapped out phone number
 * in the footer does remain on the page even after a route change. However,
 * whether this is because the callrail code is being run again or whether it's
 * simply that the footer is always present, and therefore not re-rendered
 * across route changes anyway, I don't know.
 */
let script;
export function load() {
  // Guard against running this server side.
  if(typeof document === "undefined")
    return;

  /* eslint-disable no-undef */
  if (script) {
    document.body.removeChild(script)
  }
  script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = '//cdn.callrail.com/companies/579850675/d3b423107555655e1136/12/swap.js'
  document.body.appendChild(script)
  console.log("slopejet loaded")
  /* eslint-enable */
}


// WEBPACK FOOTER //
// ./client/utility/slopejet.js